/**
 * Utility for managing cache
 */
(function() {
    var cache = {},
        //default cache expiry is 1 hour from current time
        expirySeconds = 60 * 60,
        matchCacheKey = fpUtil.regExp.matchCacheKey;

    fpUtil.cache = {
        __cache: cache,
        key: function(value) {
            matchCacheKey.lastIndex = 0;
            return S.getString(value).replace(matchCacheKey, '-');
        },
        get: function (key) {
            var item = cache[key],
                value = item && item.value;

            if (item && item.expiry !== -1 && item.expiry <= new Date()) {
                delete cache[key];
                item = null;
            }

            //remove expired
            _.defer(this.flushExpired.bind(this));

            return value;
        },
        set: function(key, value, expiry) {
            if(!_.isDate(expiry)) {
                if (!(expiry && fpUtil.isInteger(expiry))) {
                    expiry = expirySeconds;
                }
                if (expiry !== -1) expiry = dateFns.addSeconds(new Date(), expiry);
            }

            var item = cache[key];
            if(!item) item = {};

            item.value = value;
            item.expiry = expiry;

            cache[key] = item;

            return value;
        },
        remove: function(key) {
            var item = cache[key];
            delete cache[key];
            if(item) return item.value;
        },
        flush: function() {
            _.empty(cache);
        },
        flushExpired: function() {
            var item,
                now = new Date();
            for(var key in cache) {
                item = cache[key];
                if (item && item.expiry !== -1 && item.expiry <= now) {
                    delete cache[key];
                }
            }
        }
    };
})();